import {
  ROLES,
  type RoleStrategy,
  api,
  useMutation,
  useQueryClient,
  useRoleConf,
  useToaster,
} from "@pharmupp/p3-front-commons/src"
import { committeeAccessConf } from "../../CommitteeLink"
import { committeeSummaryApiConf } from "../../useCommitteeSummary"
import { committeeListRoleConf } from "../useCommitteePlatform"

export const useCPMemberActions = (userId: string) => {
  const toaster = useToaster()
  const queryClient = useQueryClient()
  const endpoint = useRoleConf(committeeMembershipRoleConf(userId))
  const list = useRoleConf(committeeListRoleConf)
  const summary = useRoleConf(committeeSummaryApiConf)
  const { status } = useRoleConf(committeeAccessConf)

  const { mutateAsync: activateMembership, isPending: isLoading } = useMutation({
    mutationFn: () =>
      api(endpoint, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }),
    onSuccess: () => {
      toaster.success("Accès CSE créé")
      queryClient.invalidateQueries({ queryKey: list.queryKey })
      queryClient.invalidateQueries({ queryKey: summary.queryKey })
      queryClient.invalidateQueries({ queryKey: status.queryKey })
    },
  })

  return { activateMembership, isLoading }
}

const committeeMembershipRoleConf = (userId: string): RoleStrategy<string> => ({
  [ROLES.ADHERENT_HOLDER]: `/api/employee-committees/adherent/members/${userId}`,
})
